
import React from 'react';
import NavigationRail from '../../components/NavigationRail';
import { AppMode, Language, User } from '../../types';

interface NavigationRailTemplateProps {
  currentMode: AppMode;
  onSwitchMode: (mode: AppMode) => void;
  language: Language;
  isOpen: boolean;
  onClose: () => void;
  user: User | null;
}

const NavigationRailTemplate: React.FC<NavigationRailTemplateProps> = (props) => {
  return (
    <NavigationRail 
      currentMode={props.currentMode}
      onSwitchMode={props.onSwitchMode}
      language={props.language}
      isOpen={props.isOpen}
      onClose={props.onClose}
      user={props.user}
    />
  );
};

export default NavigationRailTemplate;
